// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__15Lu3","name":"ConsentHeader_name__39LyT","birthday":"ConsentHeader_birthday__2E-UP","skeleton":"ConsentHeader_skeleton__1HiV1"};